"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingContainer = exports.DrawerIcon = exports.DrawerHeading = exports.DrawerContent = exports.DrawerButton = exports.CircleBorder = exports.AccordionTitleText = exports.AccordionLabelContainer = exports.AccordionDrawer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _Typography = require("../../components/Typography");
var _DynamicHeading = require("../DynamicHeading");
var _LexusTypography = require("../LexusTypography");
const stickyStyles = {
  default: `
    top: 0;
    position: sticky;
  `,
  bottom: `
    bottom: 0;
    position: sticky;
  `
};
const AccordionDrawer = exports.AccordionDrawer = _styledComponents.default.div`
  color: var(--app-primary-text-color, #000);
  display: block;
  ${function (_ref) {
  let {
    $sticky
  } = _ref;
  return $sticky ? $sticky === "bottom" ? stickyStyles.bottom : stickyStyles.default : "";
}}
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  ${function (_ref2) {
  let {
    showDecorator
  } = _ref2;
  return showDecorator ? `
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 2px;
            height: 100%;
            background-color: var(--app-primary-text-color, #000);
          }
        ` : "";
}}
`;
const DrawerButton = exports.DrawerButton = _styledComponents.default.button`
  background: none;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: ${function (_ref3) {
  let {
    showDecorator
  } = _ref3;
  return showDecorator ? "0" : "16px 0 19px";
}};
  display: block;
  position: relative;
  display: flex;
  width: 100%;

  ${function (_ref4) {
  let {
    showDecorator
  } = _ref4;
  return !showDecorator && `
    &:after {
      content: '';
      height: 1px;
      background-color: rgb(236, 236, 236);
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
    }
`;
}}

  span {
    display: block;
  }
`;
const DrawerHeading = exports.DrawerHeading = (0, _styledComponents.default)(_DynamicHeading.DynamicHeading).attrs({
  defaultLevel: 3
})`
    ${(0, _LexusTypography.nobel)({
  sizing: "heading18",
  weight: "regular"
})}
    margin: 0;
    text-align: left;
    color: ${function (_ref5) {
  let {
    $headingColor
  } = _ref5;
  return $headingColor || "var(--app-primary-text-color, #000)";
}};
    display: flex;
    justify-content: space-between;
    align-items: ${function (_ref6) {
  let {
    $selectedIcon
  } = _ref6;
  return $selectedIcon ? "" : "center";
}};
    width: 100%;
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _LexusTypography.nobel)({
  sizing: "subheading20",
  weight: "regular"
})}
    }
  `;
const HeadingContainer = exports.HeadingContainer = _styledComponents.default.div`
  display: ${function (_ref7) {
  let {
    $hideHeading
  } = _ref7;
  return $hideHeading ? "none" : "block";
}};
`;
const DrawerIcon = exports.DrawerIcon = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  max-height: 24px;
  margin-left: ${function (_ref8) {
  let {
    $marginLeft
  } = _ref8;
  return $marginLeft ? "auto" : "";
}};
  svg {
    fill: ${function (_ref9) {
  let {
    $fill
  } = _ref9;
  return $fill || "var(--app-primary-text-color, #000)";
}};
  }
`;
const DrawerContent = exports.DrawerContent = _styledComponents.default.div`
  box-sizing: border-box;
  overflow: hidden;
  transition: max-height 500ms, opacity 600ms 200ms;
  ${function (_ref10) {
  let {
    $drawerOpen,
    maxHeight
  } = _ref10;
  return `
    ${$drawerOpen ? `
      max-height: ${maxHeight ? maxHeight : "600vh"};
      opacity: 1;
      overflow: visible;
    ` : `
      &&& {
        max-height: 0!important;
      }
      opacity: 0;
      visibility: hidden;
    `}
  `;
}}
  &:after {
    content: '';
    height: 1px;
    background-color: rgb(236, 236, 236);
    width: 100%;
  }
`;
const AccordionTitleText = exports.AccordionTitleText = (0, _Typography.StyledType)("div", {
  family: "nobel-regular",
  letterSpacing: "wide"
})`
    flex: 1;
    margin-right: 0.5rem;
    display: inline-flex;
  `;
const AccordionLabelContainer = exports.AccordionLabelContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const CircleBorder = exports.CircleBorder = _styledComponents.default.div`
  position: absolute;
  right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #999B9F;
  border-radius: 50%;
  margin-left: 8px;
  width: 21px;
  height: 21px;
  background-color: #000;
  border: none;
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  svg {
    stroke: #fff;
    width: 11px !important;
    margin: 0 auto;
    display: block;
    position: relative;
    left: 0;
  }
`;